import { createStyles, makeStyles, Theme, zIndex } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  appBar: {
    top: 'auto',
    bottom: 0,
    height: 'auto',
    padding: 16,
    background: theme.color.greys[0],
    borderTop: `1px solid ${theme.color.greys[15]}`,
    zIndex: zIndex.modalZIndex,
    '& .MuiToolbar-root': {
      width: '100%',
      maxWidth: theme.space.basicDataMaxWidth,
      margin: '0 auto',
    },
  },
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  backButtonWrapper: {
    [theme.breakpoints.down('sm')]: {
      order: 3,
      width: '100%',
      textAlign: 'center',
      '& button': {
        width: '100%',
      },
    },
  },
  sumWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: 16,
      order: 1,
    },
  },
  nextButtonWrapper: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
      width: '100%',
      marginBottom: 24,
      textAlign: 'center',
      '& button': {
        width: '100%',
      },
    },
  },
  sumTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  sumErrorMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  alertIcon: {
    color: theme.color.reds[100],
    display: 'inline-flex',
    alignItems: 'center',
  },
  sumErrorText: {
    color: theme.color.greys[80],
  },
  sumErrorValue: {
    color: theme.color.reds[100],
  },
}), {name: 'CartSumBar'});
